import { ArrowRight } from "lucide-react";

export const Hero = () => {
    const scrollTo = (id) => {
        const el = document.querySelector(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <section
            id="top"
            data-testid="hero-section"
            className="relative pt-40 pb-24 lg:pt-48 lg:pb-32 bg-gradient-to-br from-slate-50 via-white to-blue-50/50 overflow-hidden"
        >
            <div className="absolute inset-0 hero-grain pointer-events-none" />
            <div className="relative max-w-4xl mx-auto px-6 lg:px-12 text-center">
                <span
                    data-testid="hero-overline"
                    className="text-xs sm:text-sm font-semibold uppercase tracking-[0.2em] text-blue-700 mb-6 block font-display"
                >
                    NextGen Systems
                </span>

                <h1
                    data-testid="hero-title"
                    className="font-display text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tighter text-slate-900 leading-[1.05]"
                >
                    Empowering Future{" "}
                    <span className="text-blue-700">Technologies</span>
                </h1>

                <p
                    data-testid="hero-description"
                    className="mt-8 text-base lg:text-lg font-normal leading-relaxed text-slate-600 max-w-2xl mx-auto"
                >
                    We build scalable mobile apps, web platforms, and
                    intelligent systems for modern businesses.
                </p>

                <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
                    <button
                        type="button"
                        onClick={() => scrollTo("#contact")}
                        data-testid="hero-cta-contact"
                        className="group inline-flex items-center justify-center px-8 py-4 bg-blue-700 hover:bg-blue-800 text-white font-medium rounded-full transition-colors duration-200"
                    >
                        Contact Us
                        <ArrowRight
                            size={16}
                            className="ml-2 transition-transform group-hover:translate-x-1"
                        />
                    </button>
                    <button
                        type="button"
                        onClick={() => scrollTo("#services")}
                        data-testid="hero-cta-services"
                        className="inline-flex items-center justify-center px-8 py-4 bg-white border border-slate-200 hover:border-slate-300 text-slate-900 font-medium rounded-full transition-colors duration-200"
                    >
                        Explore Services
                    </button>
                </div>

                <div className="mt-16 flex flex-wrap items-center justify-center gap-x-10 gap-y-4 text-xs font-medium uppercase tracking-[0.18em] text-slate-400">
                    <span>Android &amp; iOS</span>
                    <span className="h-1 w-1 rounded-full bg-slate-300" />
                    <span>Scalable Backends</span>
                    <span className="h-1 w-1 rounded-full bg-slate-300" />
                    <span>System Design</span>
                </div>
            </div>
        </section>
    );
};
